import { FC } from "react";
import { EntityTypeEnum } from "@app/projects/enumerators";
import { toNpiTypeLabel } from "@app/projects/network-assessment/network-integrity/helpers/networkIntegrityNpiTypeHelper";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkIntegrityNpiTypeFilterProps {
  npiType: EntityTypeEnum | null;
  setNpiType: (value: EntityTypeEnum | null) => void;
}

const npiTypeOptions = [EntityTypeEnum.Individual, EntityTypeEnum.Facility];

const NetworkIntegrityNpiTypeFilter: FC<NetworkIntegrityNpiTypeFilterProps> = ({ npiType, setNpiType }) => {
  return (
    <QESSelect
      allowEmpty
      label="NPI Type:"
      placeholder="All"
      testId="network-integrity-filters__npi-type"
      value={npiType ?? ""}
      onChange={(e) => setNpiType((e.target.value as EntityTypeEnum) || null)}
      className="network-integrity-filters__npi-type"
    >
      {npiTypeOptions.map((npiTypeOption) => (
        <option key={`network-integrity-filters__npi-type-option--${npiTypeOption}`} value={npiTypeOption}>
          {toNpiTypeLabel(npiTypeOption)}
        </option>
      ))}
    </QESSelect>
  );
};

export default NetworkIntegrityNpiTypeFilter;
